export enum ReservationStatusType {
    PRERESERVATION = 1,
    CONFIRMED = 2,
    CANCELED_USER = 3,
    CANCELED_CONTRACTOR = 4,
    CANCELED_BUSINESS_USER = 5,
    OBSOLETE = 6,
    CONFIRMED_DRAFT_RESERVATION = 7,
    RECURRING_EVENT = 8,
    CANCELED_DRAFT = 9,
}

// 1: prereservation, 2: confirmed, 3: canceled user, 4: canceled contractor,
// 5: canceled business_user, 6: obsolete, 7: confirmed draft reservation, 8: recurring event, 9: canceled draft
